export type IScanableItem<T> = T & {
  scanned: number;
  isCorrected?: boolean;
};
